import { render, staticRenderFns } from "./DeletedAssetTable.vue?vue&type=template&id=3f064100&scoped=true&"
import script from "./DeletedAssetTable.vue?vue&type=script&lang=js&"
export * from "./DeletedAssetTable.vue?vue&type=script&lang=js&"
import style0 from "./DeletedAssetTable.vue?vue&type=style&index=0&id=3f064100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f064100",
  null
  
)

export default component.exports